// extracted by mini-css-extract-plugin
module.exports = {"badge":"style_badge__MQZTs","headline":"style_headline__2U_gj"};